const ufeApi = require('services/api/ufeApi');
const cookieUtils = require('utils/Cookies');
const localeUtils = require('utils/LanguageLocale');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/WIP+-+GET+Same+Day+User+Specific+Product+Details+API

function getSameDaySpecificProductDetails(profileId = 'current', productId, skuId = null) {
    let url = `/api/users/profiles/${profileId}/samedayproduct/${productId}`;

    if (cookieUtils.isPXSEnabled()) {
        url = `/api/v3/users/profiles/${profileId}/samedayproduct/${productId}`;
    }

    const queryParams = [];

    if (skuId !== null) {
        const countryCode = localeUtils.isCanada() ? localeUtils.COUNTRIES.CA : localeUtils.COUNTRIES.US;
        queryParams.push(`?preferedSku=${skuId}&countryCode=${countryCode}`);
    }

    url = url + queryParams.join('&');

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getSameDaySpecificProductDetails;
